import React from 'react';
import { FC } from 'react';
import { IconProps } from '../types';

export const ProofOfDepositIcon: FC<IconProps> = ({ width = '24', height = '24', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 22 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M10.75 12.75H2.75C2.21957 12.75 1.71086 12.5393 1.33579 12.1642C0.960714 11.7891 0.75 11.2804 0.75 10.75V2.75C0.75 2.21957 0.960714 1.71086 1.33579 1.33579C1.71086 0.960714 2.21957 0.75 2.75 0.75H18.75C19.2804 0.75 19.7891 0.960714 20.1642 1.33579C20.5393 1.71086 20.75 2.21957 20.75 2.75V7.75M14.75 13.75L17.75 16.75M17.75 16.75L20.75 13.75M17.75 16.75V10.75M16.75 6.75H16.76M4.75 6.75H4.76M12.75 6.75C12.75 7.85457 11.8546 8.75 10.75 8.75C9.64543 8.75 8.75 7.85457 8.75 6.75C8.75 5.64543 9.64543 4.75 10.75 4.75C11.8546 4.75 12.75 5.64543 12.75 6.75Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
